export default __webpack_public_path__ + "static/media/1900.09e2e85b.png";